import { t } from 'i18next';
import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ImageLoader from '../../../components/mplat/ImageLoader';
import { ACCOUNT_TYPES } from '../../../const';
import { useAuth } from '../../../hooks';
import { useAccountLoginMutation } from '../../../services/api';
import { AccountProps } from '../types';

function Account({ item }: AccountProps) {
    const [params] = useSearchParams();
    const [accountLogin] = useAccountLoginMutation();
    const auth = useAuth();
    const navigate = useNavigate();

    const [error, setError] = useState('');

    return (
        <div className="user-settings__list-item" style={{ display: 'flex', cursor: 'pointer', alignItems: 'center', justifyContent: 'center' }} onClick={() => {
            accountLogin({
                refresh: auth.refreshToken,
                username: auth.user,
                account: item.id.toString()
            }).unwrap().then((z) => {
                if (!z.agr_offer) {
                    window.location.pathname !== '/agreement' && navigate('/agreement');
                    return;
                }
                const next = params.get('next');
                if (next) {
                    navigate(next);
                    return;
                }
                window.location.pathname === '/select-accounts' && navigate('/');
            }).catch((e) => {
                setError(e.message);
            });
        }}>
            {item.logo && <ImageLoader url={item.logo} maxWidth="30px" maxHeight="30px" rounded />}&nbsp;<Link to="" className="link-accent">{item.id} · {item.name} · {t(ACCOUNT_TYPES[item.rtype])}</Link>
            {error && <><br />{error}</>}
        </div>
    );
}

export default Account;
